import { Skeleton } from '@commander/ui';

export function ChartSkeleton() {
  return (
    <div className="rounded-lg border bg-card p-3">
      <Skeleton className="h-3 w-[40%]" />
      <div className="mt-3 flex items-end gap-2">
        {[60, 80, 45, 70, 55].map((h) => (
          <Skeleton key={h} className="flex-1" style={{ height: `${h}%`, minHeight: h * 1.5 }} />
        ))}
      </div>
      <Skeleton className="mt-2 h-[140px] w-full" />
    </div>
  );
}
